import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-notification-cms',
  templateUrl: './notification-cms.component.html',
  styleUrls: ['./notification-cms.component.scss']
})
export class NotificationCmsComponent implements OnInit {

  notifications: any[];
  motiNextTime: boolean;
  constructor(
    public dialogRef: MatDialogRef<NotificationCmsComponent>,
    @Inject(MAT_DIALOG_DATA) public message: any
  ) {
    dialogRef.disableClose = false;
  }

  ngOnInit() {
    if (this.message) {
      this.notifications = this.message.filter(e => {
        e['check'] = false;
        return e
      })
    }
  }

  onNoClick() {
    this.dialogRef.close(false);
  }
  onClose() {
    this.dialogRef.close(this.motiNextTime ? this.notifications : []);
  }

  checkEnable() {
    return this.notifications.some(e => e.status + '' === '0');
  }
}
